function TriggerClick() {
	var search_parameter = window.location.href.split("=")[1];
	if (search_parameter) {
		$('[data-filter="' + search_parameter + '"]').trigger('click');
	} else {
		$(".js-blog-filter").first().trigger('click');
	};
}


(function($) {

	$.fn.changeActiveFilter = function() {
		var that = this;

		$(that).on('click', function() {
			var $that = $(this);
			var $active = $(".js-blog-filter.active");
			var is_active = $that.hasClass("active");

			if (!is_active) {
				$active.removeClass("active");
				$that.addClass("active");
			}
		});
	}

	$(".js-blog-filter").changeActiveFilter();
	TriggerClick();

}(jQuery));